// SupporterOnlyNotice Component
// Displayed when a signed-in user is not a supporter

import { SupporterBadge, RevoltButtonLink } from '../../../components';

const SUPPORTER_EXPLANATION =
  'Financially supporting Revolt in any way (even one-time) gives you this badge and access to the Community tab.';

export function SupporterOnlyNotice() {
  return (
    <div className="community-panel">
      <div className="community-panel__icon">
        <SupporterBadge tooltipTitle="Supporter" tooltipText={SUPPORTER_EXPLANATION} />
      </div>
      <h1 className="community-title">Supporters only</h1>
      <p className="community-subtitle">{SUPPORTER_EXPLANATION}</p>

      <div className="community-actions">
        <RevoltButtonLink href="/pricing" data-navigation-button>
          View plans
        </RevoltButtonLink>
      </div>
    </div>
  );
}

